{
  "billing": {
    "title": "Facturación",
    "notAuthorized": "Solo los propietarios del espacio pueden gestionar la facturación."
  },
  "balance": {
    "label": "Saldo de créditos",
    "credits_one": "{{count}} crédito",
    "credits_other": "{{count}} créditos",
    "breakdown": "{{purchased}} comprados · {{granted}} de regalo"
  },
  "topUp": {
    "cta": "Recargar créditos",
    "title": "Recargar créditos",
    "subtitle": "1 crédito cubre 1 perfil.",
    "processing": "Procesando…",
    "success": "Créditos agregados",
    "settlementSlow": "Esto está tardando más de lo normal. Tu compra aparecerá pronto; revisa Facturación.",
    "continue": "Continuar",
    "back": "Regresar",
    "startFailed": "No pudimos iniciar el pago. Inténtalo de nuevo."
  },
  "amount": {
    "label": "¿Cuántos créditos?",
    "justEnough": "Lo justo",
    "aBitExtra": "Un poco más",
    "roundUp": "Redondear",
    "option": "{{credits}} por {{total}}",
    "unpriced_one": "{{count}} crédito",
    "unpriced_other": "{{count}} créditos"
  },
  "send": {
    "costSummary": "{{count}} invitaciones × {{unit}} = {{total}}. Tienes {{balance}} disponibles.",
    "topUpAndSend": "Recargar y enviar {{count}}"
  },
  "self": {
    "ctaHasCredits": "Perfílate (usa 1 crédito)",
    "ctaBuy": "Compra un perfil para ti — {{price}}",
    "askOwner": "Pide a un propietario del espacio que recargue créditos.",
    "ctaBuyUnpriced": "Compra un perfil para ti"
  },
  "checkout": {
    "loadFailed": "No pudimos cargar el formulario de pago.",
    "confirmFailed": "No pudimos comunicarnos con Stripe para enviar el pago. Inténtalo de nuevo.",
    "subtotal": "Créditos",
    "tax": "Impuestos",
    "taxPending": "Se calcula con tu dirección de facturación",
    "total": "Total",
    "pay": "Pagar {{total}}",
    "returnRetry": "Si no terminaste de pagar, puedes volver a intentarlo desde <billingLink>Facturación</billingLink>."
  },
  "price": {
    "plusTax": "{{price}} + impuestos si aplican",
    "taxHint": "+ impuestos si aplican"
  },
  "history": {
    "title": "Historial de compras",
    "empty": "Aún no hay compras.",
    "creditsColumn": "Créditos",
    "date": "Fecha",
    "amount": "Monto",
    "invoice": "Factura",
    "invoicePending": "Preparando…",
    "invoiceNotReady": "Tu factura aún se está preparando. Inténtalo de nuevo en un minuto.",
    "downloadFailed": "No se pudo descargar la factura. Inténtalo de nuevo más tarde."
  }
}
